import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

//action types
export const UPDATE_TOTE_DATA = "updateWMSPACKINGToteData";
export const UPDATE_SKU_TASKS = "updateWMSPACKINGSkuTasks";
export const CONFIRM_SINGLE_PACKING = "confirmWMSPACKINGSinglePacking";
export const CONFIRM_BATCH_PACKING = "confirmWMSPACKINGBatchPacking";

//mutation types
export const SET_ORDERS_TABLE_DATA = "setWMSPACKINGOrdersTableData";
export const SET_PICK_TYPE = "setWMSPACKINGPickType";
export const SET_TASKS_DATA = "setWMSPACKINGTasks";
export const SET_SKU_TASKS = "setWMSPACKINGSkuTasks";
export const SET_VIRTUAL_SKU_TAKS = "setWMSPACKINGVirtualSkuTasks";
export const SET_SELECTED_TOTE = "setWMSPACKINGSelectedTote";
export const SET_SEARCHED_SKU = "setWMNSPACKINGSearchedSku";
export const SET_BATCH_PACKING_BOX = "setWMSPACKINGBatchPackingBox";
export const SET_PACKING_RESPONSE = "setWMSPACKINGResponse";
export const UPDATE_SKU_TASK_QTY = "updateWMSPACKINGSkuTaskQty";
export const UPDATE_VIRTUAL_SKU_TASK_QTY = "updateWMSPACKINGVirtualSkuTaskQty";

const state = {
  orders_table_data: null,
  pick_type: null,
  tasks: null,
  sku_tasks: null,
  virtual_sku_tasks: null,
  selected_tote: null,
  searched_sku: null,
  batch_packing_box_items: [],
  packing_response: {
    message: "",
    status: false,
    success: false,
  },
};

//getters
const getters = {
  getWMSPACKINGOrdersTableData(state) {
    return state.orders_table_data;
  },
  getWMSPACKINGPickType(state) {
    return state.pick_type;
  },
  getWMSPACKINGSKUTasks(state) {
    return state.sku_tasks;
  },
  getWMSPACKINGVirtualSKUTasks(state) {
    return state.virtual_sku_tasks;
  },
  getWMSPACKINGSelectedTote(state) {
    return state.selected_tote;
  },
  getWMSPACKINGSearchedSku(state) {
    return state.searched_sku;
  },
  getWMSPACKINGBatchPackingBox(state) {
    return state.batch_packing_box_items;
  },
  getWMSPACKINGRespose(state) {
    return state.packing_response;
  },
};

// actions
const actions = {
  [UPDATE_TOTE_DATA](context, payload) {
    context.commit(SET_ORDERS_TABLE_DATA, null);
    context.commit(SET_SKU_TASKS, null);
    context.commit(SET_PICK_TYPE, null);
    context.commit(SET_SELECTED_TOTE, null);
    context.commit(SET_BATCH_PACKING_BOX, null);
    context.commit(SET_PACKING_RESPONSE, {
      message: "",
      status: false,
      success: false,
    });
    context.commit(SET_PAGE_LOADING, true);

    return new Promise((resolve) => {
      ApiService.post(`/warehouse_management/packing/show`, payload)
        .then(({ data }) => {
          context.commit(SET_ORDERS_TABLE_DATA, data.orders);
          context.commit(SET_PICK_TYPE, data.pick_type);
          if (data.pick_type === 1) {
            context.commit(SET_TASKS_DATA, data.tasks);
            context.commit(SET_SKU_TASKS, null);
          } else if (data.pick_type === 2) {
            context.commit(SET_SKU_TASKS, data.tasks);
          }
          context.commit(SET_SELECTED_TOTE, payload.tote_id);
          resolve;
        })
        .finally(() => {
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
  [UPDATE_SKU_TASKS](context, payload) {
    context.commit(SET_PAGE_LOADING, true);

    return new Promise((resolve) => {
      ApiService.post(`/warehouse_management/packing/search_sku`, payload)
        .then(({ data }) => {
          context.commit(SET_SKU_TASKS, data.tasks);
          context.commit(SET_SEARCHED_SKU, payload.sku);
          resolve;
        })
        .finally(() => {
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
  async [CONFIRM_SINGLE_PACKING](context, payload) {
    await ApiService.post(`/warehouse_management/packing/update`, payload)
      .then((res) => {
        context.commit(SET_PACKING_RESPONSE, res.data);
        Swal.fire({
          title: `Updated`,
          text: `Packing updated successfully`,
          icon: "success",
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .finally(() => {
        // context.commit(SET_SKU_TASKS, null);
        context.commit(SET_PAGE_LOADING, false);
      });
  },
  async [CONFIRM_BATCH_PACKING](context, payload) {
    await ApiService.post(`/warehouse_management/packing/update`, payload)
      .then((res) => {
        context.commit(SET_PACKING_RESPONSE, res.data);
        Swal.fire({
          title: `Updated`,
          text: `Packing updated successfully`,
          icon: "success",
          showConfirmButton: false,
          timer: 2500,
        });
      })
      .finally(() => {
        // context.commit(SET_SKU_TASKS, null);
        // context.commit(SET_BATCH_PACKING_BOX, []);
        context.commit(SET_PAGE_LOADING, false);
      });
  },
};

// mutations
const mutations = {
  [SET_ORDERS_TABLE_DATA](state, payload) {
    state.orders_table_data = payload;
  },
  [SET_PICK_TYPE](state, pickingType) {
    state.pick_type = pickingType;
  },
  [SET_TASKS_DATA](state, tasks) {
    state.tasks = tasks;
  },
  [SET_SKU_TASKS](state, skus) {
    state.sku_tasks = skus;
  },
  [SET_VIRTUAL_SKU_TAKS](state, skus) {
    state.virtual_sku_tasks = skus;
  },
  [SET_SELECTED_TOTE](state, tote) {
    state.selected_tote = tote;
  },
  [SET_SEARCHED_SKU](state, sku) {
    state.searched_sku = sku;
  },
  [SET_BATCH_PACKING_BOX](state, item) {
    if (item) {
      state.batch_packing_box_items = [...state.batch_packing_box_items, item];
    } else state.batch_packing_box_items = [];
  },
  [UPDATE_SKU_TASK_QTY](state, item) {
    const index = state.sku_tasks.findIndex(
      (element) =>
        element.sku.text1 === item.sku && element.tote_id === item.tote_id
    );

    state.sku_tasks[index].qty -= Number(item.packed_qty);
    if (state.sku_tasks[index].qty > 0) {
      state.sku_tasks[index].wms_status_label = "Partially packed";
    } else state.sku_tasks[index].wms_status_label = "Packed";
  },
  [UPDATE_VIRTUAL_SKU_TASK_QTY](state, item) {
    const index = state.virtual_sku_tasks.findIndex(
      (element) =>
        element.sku.text1 === item.sku.text1 && element.tote_id === item.tote_id
    );
    state.virtual_sku_tasks[index].qty -= Number(item.qty);
  },
  [SET_PACKING_RESPONSE](state, res) {
    state.packing_response = res;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
